import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M9.25 13.37A1.13 1.13 0 0 1 8 14.62a1.13 1.13 0 0 1-1.25-1.25h2.5ZM13 11.18a1.75 1.75 0 0 1-.84-1.46V6.9A4.52 4.52 0 0 0 8.6 2.46a.79.79 0 0 0 .12-.41.72.72 0 1 0-1.44 0 .79.79 0 0 0 .12.41A4.52 4.52 0 0 0 3.82 6.9v2.82A1.75 1.75 0 0 1 3 11.18a.74.74 0 0 0-.37.84.75.75 0 0 0 .72.57h9.32a.75.75 0 0 0 .72-.57.74.74 0 0 0-.39-.84Z';
const draw24px =
  'M12,22.36a1.8,1.8,0,0,1-2-2h4A1.8,1.8,0,0,1,12,22.36Zm7.82-4.51a3.25,3.25,0,0,1-1.57-2.74V10.59a6.74,6.74,0,0,0-5.76-6.73A1.15,1.15,0,0,0,12,1.67a1.15,1.15,0,0,0-.49,2.19,6.75,6.75,0,0,0-5.77,6.73v4.52a3.24,3.24,0,0,1-1.56,2.74.75.75,0,0,0-.38.84.76.76,0,0,0,.73.57H19.47a.76.76,0,0,0,.73-.57A.75.75,0,0,0,19.82,17.85Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BellFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bellFilled'),
) as IconWithRender;

BellFilledIcon.displayName = 'BellFilledIcon';
BellFilledIcon.propTypes = Icon.propTypes;
BellFilledIcon.renderIcon = (props) => <BellFilledIcon {...props} />;
export default BellFilledIcon;
